import * as React from 'react';
import ReactModal from 'react-modal';
import bind from 'bind-decorator';
import IconClose from "../Icons/IconClose";

export interface Props {
    isOpen: boolean;
    contentRef?: (e: HTMLDivElement) => void;
    onRequestClose?: () => void;
    body?: string;
    className?: string;
}

class Modal extends React.Component<Props> {

    private contentRef: HTMLDivElement | undefined

    disableScroll() {
        const bodyElem = document.querySelector('body');
        if (bodyElem) {
            bodyElem.classList.add('body__scroll-locked');
        }
    }

    enableScroll() {
        const bodyElem = document.querySelector('body');
        if (bodyElem) {
            bodyElem.classList.remove('body__scroll-locked');
        }
    }

    setContentRef(ref: HTMLDivElement) {
        this.contentRef = ref

        if (this?.props?.contentRef) {
            this.props.contentRef(ref)
        }
    }

    onAfterOpen() {
        if (this.contentRef) {
            this.disableScroll()
        }
    }

    onRequestClose() {
        const { onRequestClose } = this.props

        if (onRequestClose) {
            onRequestClose()
        }

        if (this.contentRef) {
            this.enableScroll();
        }
    }

    componentWillUnmount() {
        this.enableScroll();
    }

    render() {
        const { className = '', isOpen, contentRef, body, children } = this.props
        ReactModal.setAppElement('body');
        const modalProps: ReactModal.Props = {
            isOpen,
            portalClassName: `modal ${className}`,
            overlayClassName: 'modal__overlay',
            className: 'modal__content-wrapper',
            contentRef: this.setContentRef,
            onAfterOpen: () => this.onAfterOpen(),
            onRequestClose: () => this.onRequestClose(),
            shouldCloseOnEsc: true
        }
        return (
            <ReactModal {...modalProps}>
                {body && <div dangerouslySetInnerHTML={{__html: body}} className='modal__content'/>}
                {children}
                <button onClick={modalProps.onRequestClose} className='modal__close button-style-4'>
                    <IconClose/>
                </button>
            </ReactModal>
        );
    }
}

export default Modal;
